module.exports = __webpack_public_path__ + "static/banner-bg-10f022e086b7946d0da180a64eeecb34.jpg";